import { CpuCount } from "@pdfking/compatibility"
import type { Executor, TaskMap } from "@pdfking/planner"

import type { ExecutionContext, TaskEngineOptions, TaskModule } from "#public"

import { CreateEngine } from "./CreateEngine"
import { CreateWorkerEngine } from "./CreateWorkerEngine"

export const CreateTaskEngine = <TM extends TaskMap>(
  tasks: TaskModule<TM>,
  { worker, workers, ...options }: TaskEngineOptions = {}
): Executor<TM, ExecutionContext> => {
  const count = workers ?? CpuCount()
  // one worker is no worker: the thread handing work over is the only one there is
  return worker && count > 1
    ? CreateWorkerEngine<TM>(tasks.TasksDescriptor, { ...options, worker, workers: count })
    : CreateEngine<TM>(tasks.Tasks, tasks.TasksDescriptor, options)
}
